import { Injectable } from '@angular/core';
import { Operations } from './enum/operations';
import { BehaviorSubject } from 'rxjs';
import { StoreKey } from '../store/ngrx-store.keys';
import { AuthGuardMessageService } from './auth-guard.message.service';
import { UserManagementDataService } from 'src/app/shared/data-service/user-management-data.service';
import { StoreService } from 'projects/dop-core/src/public-api';
import { PermissionScope } from 'src/app/shared/enums/permission-scope.enum';
import { UserType } from 'src/app/shared/enums/user-type.enum';
import { UserDetails } from 'src/app/shared/models/user-details.model';
import { IntercoEleAccountMapping, IntercoEleAccountDetails } from 'src/app/shared/models/ele-account.model';

@Injectable()
export class UserAuthService {

  private userInfo: UserDetails;
  private intercoEleAccountMappings: IntercoEleAccountMapping[] = [];
  private intercoEleAccountDetails: IntercoEleAccountDetails[] = [];
  isUserDataLoaded$ = new BehaviorSubject<boolean>(false);

  constructor(
    private storeService: StoreService,
    private userManagementService: UserManagementDataService,
    private authGuardMessageService: AuthGuardMessageService) {
  }

  getUserDetails() {
    this.userManagementService.getUserData().subscribe((userData: UserDetails) => {
      // Used to set translation Language
      sessionStorage.setItem('LanguageCode', userData.profile.languageIsoCode);
      const isInternalUser = userData.profile.userType.toString().toLowerCase() !== UserType[0].toString().toLowerCase();
      this.userManagementService.getUserPermission(isInternalUser).subscribe(userPermission => {
        this.userManagementService.getUserApplicationPermissions(PermissionScope.EOL).subscribe(operationPermission => {
          // Adding Property hasGuidedOrderingPermission to check in authGuard
          // if the user has permission to login to application or not
          userData.profile.applicationOperations = operationPermission.applicationOperationNames;
          userData.profile.scopeOperations = operationPermission.accountOperationPermissions;
          if (!isInternalUser) {
            const userAccountOperations = JSON.stringify(userPermission.map((x: any) => x.operations));
            userData.profile.hasGuidedOrderingPermission = userAccountOperations.indexOf(Operations.CanManageGuidedOrdering) > -1;
          } else {
            userData.profile.hasGuidedOrderingPermission =
              operationPermission.applicationOperationNames.indexOf(Operations.CanManageGuidedOrdering) > -1;

          }
          this.userInfo = userData;
          this.storeService.Save(StoreKey.UserDetails, userData, true);
          
          if (isInternalUser) {
            const elesWithFullAccess = Object.keys(userData.eles).filter(eleCode => userData.eles[eleCode] === null);
            
            this.intercoEleAccountMappings = [];
            Object.keys(userData.eles).forEach(eleCode => {
              if (userData.eles[eleCode] !== null) {
                this.intercoEleAccountMappings.push({
                  intercoEleCode: eleCode,
                  accountCodes: userData.eles[eleCode].map(ele => ele.accountCode)
                });
              }
            });
            
            this.storeService.Save(StoreKey.UserPermission, elesWithFullAccess, true);
            
            this.fetchIntercoEleAccountDetails();
          } else {
            this.storeService.Save(StoreKey.UserPermission, userPermission, true);
          }
          
          this.authGuardMessageService.userDataLoaded.next(true);
        });
      });

    });
    return this.userInfo;
  }

  get userDetails(): UserDetails {
    return this.userInfo;
  }

  private fetchIntercoEleAccountDetails(): void {
    const allIntercoAccountCodes = this.intercoEleAccountMappings
      .flatMap(mapping => mapping.accountCodes)
      .filter((code, index, self) => self.indexOf(code) === index);

    if (allIntercoAccountCodes.length === 0) {
      return;
    }

    this.userManagementService.getAccountsByAccountCodes(allIntercoAccountCodes).subscribe(intercoAccounts => {
      this.intercoEleAccountDetails = this.intercoEleAccountMappings.map(mapping => ({
        intercoEleCode: mapping.intercoEleCode,
        accounts: intercoAccounts.filter(account => mapping.accountCodes.includes(account.code))
      }));
      
      this.storeService.Save(StoreKey.IntercoEleAccountDetails, this.intercoEleAccountDetails, true);
    });
  }
}
